<template>
    <div class="container mx-auto page p-3">
        <div>
            <router-link to="/home" class="text-blue-500 underline font-bold">Home</router-link>
        </div>
        <div class="text-gray-700 text-lg font-bold underline">Delivery Address</div>
        <div class="mb-5">
            <button class="bg-green-500 text-white py-1 px-4 rounded-md mr-2"
                    @click="clickAddAddress()" data-cy="btn_page_delivery_address_add">Add new address</button>
            <button class="bg-gray-600 text-white py-1 px-4 rounded-md"
                    @click="clickListAddressModal()" data-cy="btn_page_delivery_address_list">Modal address list</button>
        </div>

        <AddressList
                ref="address-list"
                @onEditAddress="clickEditAddress($event)"
                @onDeleteAddress="clickDeleteAddress($event)"
                data-cy="component_page_delivery_address_list"
        ></AddressList>

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
//component
import AddressList from "../component/AddressList.vue";
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
//service
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";

export default {
    name: "DeliveryAddress",
    mixins: [ModalMixin],
    components: {
        AddressList
    },
    methods: {
        //#region mixin function
        onSetupModalCompleted: function() {
            this.initialAddressModal();
        },
        //#endregion mixin function

        reloadAddressList: function() {
            this.$refs['address-list'].getAddressList();
        },

        clickAddAddress: function() {
            this.addAddressModal.clearModal().show();
            this.addAddressModal.onAddSuccess(() => {
                this.reloadAddressList();
            });
        },
        clickEditAddress: function(address) {
            this.editAddressModal
                    .clearModal()
                    .setAddress(address)
                    .show();
            this.editAddressModal.onEditSuccess(() => {
                this.reloadAddressList();
            });
        },
        clickDeleteAddress: function(address) {
            this.confirmModal.clearModal()
                    .setMsg("ต้องการลบ Address " + address.addressName + " ?")
                    .show()
            this.confirmModal.onClickOk(() => {
                this.apiDeleteAddress(address);
            });
        },

        apiDeleteAddress: function(address) {
            this.loadingModal.show();

            BzbsAddressList.apiDeleteAddress(address.rowKey).subscribe({
                next: () => {
                    this.loadingModal.hide();
                    this.reloadAddressList();
                },
                error: (err) => {
                    this.loadingModal.hide();
                    this.errorApi(err);
                }
            });
        },

        clickListAddressModal: function() {
            this.listAddressModal.show();
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
